"use client";

import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import Slider from "react-slick";

import RecipeGridItem from "@/components/recipe/gridItem";
import GridItemRedesign from "@/components/recipe/gridItemRedesign";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const commonClassNames =
  "absolute !top-1/2 z-10 !h-7 !w-7 cursor-pointer !bg-white/50 !text-black transition-colors duration-200";
const newDesignClassNames = (newDesign: boolean) =>
  newDesign
    ? "rounded-full !bg-white/75"
    : "!bg-white/50  hover:stroke-blue-400";

function NextArrow({
  newDesign = false,
  onClick = () => {
    return;
  },
}) {
  return (
    <ChevronRightIcon
      className={clsx(
        `!right-0 mr-1 ${commonClassNames}`,
        newDesignClassNames(newDesign),
      )}
      onClick={onClick}
    />
  );
}

function PrevArrow({
  newDesign = false,
  onClick = () => {
    return;
  },
}) {
  return (
    <ChevronLeftIcon
      className={clsx(
        `!left-0 ml-1 ${commonClassNames}`,
        newDesignClassNames(newDesign),
      )}
      onClick={onClick}
    />
  );
}

export default function RecipeCarousel({
  className = "",
  recipes = [] as Recipe[],
  newDesign = false,
  carouselSettings = {},
}) {
  const settings = {
    autoplay: true,
    autoplaySpeed: 4000,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    arrows: true,
    speed: 500,
    nextArrow: <NextArrow newDesign={newDesign} />,
    prevArrow: <PrevArrow newDesign={newDesign} />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
    ...carouselSettings,
  };

  return (
    // @ts-expect-error Suddenly started complaining
    <Slider
      {...settings}
      className={clsx(
        className,
        "relative",
        newDesign ? "carousel-slider px-0" : "mx-6 px-12",
      )}
    >
      {recipes.map((recipe, index: number) =>
        newDesign ? (
          <GridItemRedesign
            key={recipe.title ?? "" + index}
            recipe={recipe}
            index={index}
          />
        ) : (
          <RecipeGridItem
            key={recipe.title ?? "" + index}
            recipe={recipe}
            index={index}
          />
        ),
      )}
    </Slider>
  );
}
